import React, { useEffect, useCallback } from "react";
import detectEthereumProvider from "@metamask/detect-provider";

import { connect } from "react-redux";
import * as actionTypes from "../store/actions";

import styled from "styled-components";
import Faucet from "../contracts/Faucet.json";
import Web3 from "web3";

const H1 = styled.h1`
  color: #555;
`;

let web3;
let provider;
let faucet;
let accounts = [];

const Header = (props) => {
  const {
    setAddress,
    setIsLoading,
    setShowMetaMaskButton,
    setShowFundOption,
    setMessage,
    setHasError,
    setFaucet,
    setAccounts,
  } = props;

  const messageEvent = (error, result) => {
    let isError = result.returnValues.isError;
    let message = result.returnValues.message;
    var realMassage = "";
    if (message === "faucet-is-depleted") {
      realMassage = "The faucet has been depleted, please try again later.";
    } else if (message === "fund-is-emptied") {
      realMassage = "The fund has been emptied.";
    } else if (message === "top-up-successful") {
      realMassage = "The top up has been successful.";
    } else if (message === "invalid-funding-option") {
      realMassage = "Please enter valud funding option.";
    }
    if (message) {
      setMessage(realMassage);
      setIsLoading(false);
      setHasError(isError);
    }
  };

  const leftOverTimeEvent = (error, result) => {
    let totalSeconds = result.returnValues.time;
    if (totalSeconds) {
      let hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      var timeText = seconds + " secs";
      if (minutes) {
        timeText = minutes + " mins " + timeText;
      }
      if (hours) {
        timeText = hours + " hrs " + timeText;
      }
      setMessage("Time till next funding: " + timeText);
      setIsLoading(false);
      setHasError(true);
    }
  };

  const startFaucet = (networkId) => {
    const deployedNetwork = Faucet.networks[networkId];
    faucet = new web3.eth.Contract(
      Faucet.abi,
      deployedNetwork && deployedNetwork.address
    );
    setFaucet(faucet);
    faucet.events.Message(messageEvent);
    faucet.events.LeftOverTime(leftOverTimeEvent);
    faucet.events.Funded(fundedEvent);
    if (accounts.length !== 0) {
      setAddress(accounts[0]);
      setShowMetaMaskButton(false);
      setShowFundOption(true);
    } else {
      setAddress("");
      setShowMetaMaskButton(true);
      setShowFundOption(false);
    }
    setMessage("");
    setHasError(false);
  };

  const fundedEvent = (error, result) => {
    let receiver = result.returnValues.receiver;
    let amount = result.returnValues.amount;
    if (amount) {
      let ether = amount / 10e17;
      setMessage(receiver + " is funded with " + ether + " ether");
      setIsLoading(false);
      setHasError(false);
    }
  };

  const networkChange = (chainId) => {
    console.log("chainId: " + chainId);
    //startFaucet(5777);
    if (parseInt(chainId) === 4) {
      startFaucet(4);
    } else {
      setHasError(true);
      setMessage(
        "Please select Rinkeby network on Metamask and reload your browser."
      );
      setShowMetaMaskButton(false);
      setShowFundOption(false);
    }
  };

  const startApp = async () => {
    if (provider !== window.ethereum) {
      console.error("Do you have multiple wallets installed?");
    } else {
      provider.autoRefreshOnNetworkChange = false;
      provider.on("chainChanged", networkChange);
      web3 = new Web3(provider);
      const chainId = await provider.request({
        method: "eth_chainId",
      });
      accounts = await provider.request({
        method: "eth_accounts",
      });
      setAccounts(accounts);
      const connected = await provider.isConnected();
      if (connected) {
        networkChange(chainId);
      } else {
        console.log("NOT connected");
      }
    }
  };

  const getState = useCallback(async () => {
    provider = await detectEthereumProvider();
    if (provider) {
      startApp(provider);
    } else {
      console.log("Please install MetaMask!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getState();
  }, [getState]);

  return (
    <div>
      <H1>ETH Faucet</H1>
      {props.showFundOption ? <p>Wallet Address: {props.address}</p> : null}
      {props.message ? (
        <p
          style={
            props.hasError
              ? { color: "red", fontWeight: "bold" }
              : { color: "blue", fontWeight: "bold" }
          }
        >
          {props.message}
        </p>
      ) : null}

      <hr />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    accounts: state.accounts,
    faucet: state.faucet,
    message: state.message,
    address: state.address,
    hasError: state.hasError,
    showFundOption: state.showFundOption,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (value) =>
      dispatch({ type: actionTypes.SET_ISLOADING, value: value }),
    setAddress: (value) =>
      dispatch({ type: actionTypes.SET_ADDRESS, value: value }),
    setShowMetaMaskButton: (value) =>
      dispatch({ type: actionTypes.SET_SHOWMETAMASKBUTTON, value: value }),
    setShowFundOption: (value) =>
      dispatch({ type: actionTypes.SET_SHOWFUNDOPTION, value: value }),
    setMessage: (value) =>
      dispatch({ type: actionTypes.SET_MESSAGE, value: value }),
    setHasError: (value) =>
      dispatch({ type: actionTypes.SET_HASERROR, value: value }),
    setFaucet: (value) =>
      dispatch({ type: actionTypes.SET_FAUCET, value: value }),
    setAccounts: (value) =>
      dispatch({ type: actionTypes.SET_ACCOUNTS, value: value }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
